import { CHAR_WIDTH_IN_PIXEL, LANE_PADDING, MIN_SHAPE_WIDTH } from "@/settings/settings.js";

import { type IPileupParams } from "./track-pileup-factory.js";

// Mappings
export const transcriptMappingShapePileupParams: IPileupParams = {
  featureHeight: 8,
  lanePadding: LANE_PADDING,
  labelHeight: 12,
  minShapeWidth: MIN_SHAPE_WIDTH,
  charWidthInPixel: 6,
  maxLanes: 10,
  showSeqBoxes: false,
  showSeqLetters: false,
};

export const aaRectFeatureHeight = 8;
export const aaSeqFeatureHeight = 14;

export const proteinMappingShapePileupParams: IPileupParams = {
  featureHeight: aaRectFeatureHeight,
  lanePadding: LANE_PADDING,
  labelHeight: 12,
  minShapeWidth: MIN_SHAPE_WIDTH,
  charWidthInPixel: 6,
  maxLanes: 10,
  showSeqBoxes: false,
  showSeqLetters: false,
  canvasWidth: 0,
};

export const MIN_PIXEL_PER_BASE_AA_BOX = 1;
export const MIN_PIXEL_PER_BASE_AA_LETTER = 2.8;

// Genes
export const geneShapePileupParams: IPileupParams = {
  featureHeight: 16,
  lanePadding: LANE_PADDING,
  labelHeight: null, // the label is included in the shape size
  minShapeWidth: MIN_SHAPE_WIDTH,
  charWidthInPixel: CHAR_WIDTH_IN_PIXEL,
  maxLanes: 10,
};

// Features
export const gSeqShapePileupParams: IPileupParams = {
  featureHeight: 5,
  lanePadding: LANE_PADDING,
  labelHeight: null, // the label is included in the shape size
  minShapeWidth: MIN_SHAPE_WIDTH,
  charWidthInPixel: CHAR_WIDTH_IN_PIXEL,
  maxLanes: 10,
};

// Variants
export const variantShapePileupParams: IPileupParams = {
  featureHeight: 16,
  lanePadding: LANE_PADDING,
  labelHeight: null, // the label is not shown above the feature, in fact no label is shown at all
  minShapeWidth: 2,
  charWidthInPixel: CHAR_WIDTH_IN_PIXEL,
  maxLanes: 4,
  boxHeight: 12,
};

// Bed Features
export const bedShapePileupParams: IPileupParams = {
  featureHeight: 10,
  lanePadding: LANE_PADDING,
  labelHeight: null, // the label is included in the shape size
  minShapeWidth: MIN_SHAPE_WIDTH,
  charWidthInPixel: CHAR_WIDTH_IN_PIXEL,
  maxLanes: 10,
};
